import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { routes } from './router/index';
import './App.css';

function App() {
  const renderRoutes = (routes) => {
    return routes.map((route) => (
      <Route
        key={route.path || route.index}
        path={route.path}
        element={route.element}
        index={route.index}
      >
        {route.children && renderRoutes(route.children)}
      </Route>
    ));
  };

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
      { renderRoutes(routes) }
      </Routes>
    </Router>
  );
}

export default App;